"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    PENDING: 'PENDING',
    SUBMITTED: 'SUBMITTED',
    PAID: 'PAID',
    DELETED: 'DELETED',
};
//# sourceMappingURL=invoiceStatusTypes.js.map